import * as React from 'react';

import { TagContent } from './tag-content';
import * as Styled from './tag.styles';
import type { PlaceholderTagProps } from './tag.types';

export const PlaceholderTag = React.forwardRef<
  HTMLDivElement,
  PlaceholderTagProps
>(
  (
    {
      children,
      className,
      fontWeight,
      leadingIcon: LeadingIcon,
      maxWidth = '330px',
      profile,
      showMiniBadge,
      size = 'medium',
      slotContent,
      trailingIcon: TrailingIcon,
      ...props
    },
    forwardedRef
  ): JSX.Element => {
    return (
      <Styled.PlaceholderTag
        $fontWeight={fontWeight}
        $size={size}
        className={className}
        data-xds="PlaceholderTag"
        ref={forwardedRef}
        role="presentation"
        tabIndex={-1}
        {...props}
      >
        <TagContent
          badgeProps={undefined}
          disabled={false}
          leadingIcon={
            LeadingIcon && (
              <LeadingIcon aria-hidden="true" width={18} height={18} />
            )
          }
          maxWidth={maxWidth}
          profile={profile}
          selected={false}
          showMiniBadge={showMiniBadge}
          size={size}
          slotContent={slotContent}
          trailingIcon={
            TrailingIcon && (
              <TrailingIcon aria-hidden="true" width={18} height={18} />
            )
          }
        >
          {children}
        </TagContent>
      </Styled.PlaceholderTag>
    );
  }
);

PlaceholderTag.displayName = 'PlaceholderTag';
